<script lang="ts" setup>   
    import '../../css/choice.css';
    import {onMounted,reactive,watch,computed} from 'vue';
    import {GetMedInteractionComment,IRxInteractionComment,IMedInformationInput,medInformationType,
            printClass,no_drug_information,UpdateInteractionComment, IInteractionCommentInputs,removeBadChars,errorReturnMessage} from '../lib/Models/InteractionModel'; 
    import ActionButtonV2 from '../components/ActionButtonV2.vue';
    import {ActionButtonStyle} from '../lib/Types/Types';
    import {ButtonDisplaySize,ButtonDisplayStyle} from "../Enums/UiEnums"; 
    import {confirmDialog,popAlert} from '../lib/Notification';

    const formData = reactive <
    {   
        medRetrieved: boolean,  
        interactionList? : IRxInteractionComment[],
        noData: boolean,
        medErrorMessage? : string
    }>
    ({     
        medRetrieved : false,  
        noData: true,
        medErrorMessage: ""
    });
    onMounted(() => {  
    });
    const props = withDefaults( defineProps<
        {
            showDialog: boolean, 
            patientID: number,
            prescriptionID?: number,
            medicationID?: number,
            displayHeight? : number
        }>(),
        {
            showDialog: false,
            patientID: 0,
            prescriptionID: 0,
            medicationID: 0,
            displayHeight : 350
        });

    watch(() => props.showDialog, (newShow,oldShow) => { 
        if ((newShow) && (newShow !== oldShow) && (!formData.medRetrieved)) { 
            getInteractionComment();
        }
    });

    const emit=defineEmits(["updateModalComment"]);  
    const commentHeight = computed<string>(() => (props.displayHeight - 55) + 'px'); 

    async function getInteractionComment() : Promise<void> {   
        const medInputs : IMedInformationInput = {InformationType: medInformationType.InteractionComments, PatientID: props.patientID, PrescriptionID: props.prescriptionID, MedID: props.medicationID};
        const respGet = await GetMedInteractionComment(medInputs);  
        
        if (!respGet.success) {  
            formData.medErrorMessage = respGet.error?.error ?? errorReturnMessage.comments;  
            return;
        } 
        formData.noData = (respGet.success.interactionList.length === 0 ? true : false);
        formData.medRetrieved = true; 
        formData.interactionList = respGet.success.interactionList;  
        
        if (formData.interactionList) {
            if ((formData.interactionList.length ?? 0) > 0) {
                const report_data = 
                    `<div style="${printClass.recordTitle}">Interaction Comments</div>` +
                    "<ol>" + formData.interactionList.map(item => "<li><div style=\"padding-top: .5rem;\">" + item.localCommentDate + " " + item.userName + "</div><div>" + item.comment + "<div></li>").join("") + "</ol>";
                emit('updateModalComment',true,report_data); 
            } 
        } 
    }
    async function addInteractionComment() : Promise<void> {
        resetNewInteractionComment();
        const comment_html =
            `<div class="text-isalus-primary" style="font-size: 1rem; padding-bottom: 1rem;">Enter the new Interaction Comment information below:</div>` +
            `<div style="font-size: .75rem">Comment:&nbsp;</div>` +
            `<textarea style="font-size: .75rem; width: 75%;" type="text" maxlength="1000" onchange="newInteractionComment(this.value)"></textarea>`; 
        const result = await confirmDialog(comment_html, { titleHTML: `Add New Interaction Comment`,RejectText: "Cancel", ConfirmText: "Save" });  
        if (!result) { 
            return;
        }
        const new_comment = removeBadChars(getNewInteractionComment(),'"<>~|');
        if (!new_comment) {
            popAlert("Missing Interaction Comment.");
            return;
        }  
        const commentInputs : IInteractionCommentInputs = {PrescriptionID: props.prescriptionID, Comment: new_comment};
        const respSave = await UpdateInteractionComment(commentInputs);

        if (respSave.error) {  
            popAlert(respSave.error.error ?? "Unable to add Interaction Comment.");
            return;
        }
        if (respSave.success)  {
            if (respSave.success.errorCode !== 0)  {
                popAlert(respSave.success.errorMessage ?? "Unable to add Interaction Comment.");
                return;
            }
            formData.interactionList?.push({userName: "You", localCommentDate: "Today", comment: new_comment}); 
            formData.noData = false;
        }   
    } 
    function resetNewInteractionComment() {
        new_interaction_comment = ""; // value located on razor page ...
    } 
    function getNewInteractionComment() {
        return new_interaction_comment ?? ""; // value located on razor page ...
    }
</script>
<template> 
    <div class="row pt-2"> 
        <div v-if="formData.medErrorMessage" class="col text-danger"> 
            {{ formData.medErrorMessage }}
        </div>
        <div v-if="!formData.medErrorMessage" class="col"> 
            <div class="row"> 
                <div class="fw-bold fs-6 text-isalus-primary pb-2 ">
                    Interaction Comments
                </div>
            </div>
            <div class="row"> 
                <div class="col skinnyscroll " :style="{'overflow-y': 'scroll', 'overflow-x': 'hidden', 'height': commentHeight}"> 
                    <div v-if="formData.noData" class="text-muted"> 
                        {{ no_drug_information }}
                    </div>
                    <div v-if="!formData.noData" v-for="commentRecord in formData.interactionList"> 
                        <div class="text-muted"> 
                            {{commentRecord.localCommentDate}}&nbsp;&nbsp;{{commentRecord.userName}}
                        </div>   
                        <div class="text-muted pb-2"> 
                            {{commentRecord.comment}}
                        </div>  
                    </div>  
                </div>
            </div>
            <div v-if="props.prescriptionID" class="row"> 
                <div class="col text-end"> 
                    <ActionButtonV2 
                        :action="ActionButtonStyle.Add"  
                        :text="'Add'"  
                        :tooltip="'Add a new Interaction Comment'"  
                        :size="ButtonDisplaySize.Small" 
                        :displayStyle="ButtonDisplayStyle.OutlinePrimary"  
                        :performAction="addInteractionComment" 
                        :disabled="false" />
                </div>
            </div>
        </div>
    </div>
</template>